import React from "react";

import UILoader from "./Loader";
import Backdrop from "components/UI/Backdrop/Backdrop";

const UIFullScreenLoader = props => {
  return (
    <Backdrop>
      <UILoader {...props} />
    </Backdrop>
  );
};

export default UIFullScreenLoader;
